import { toast } from 'react-toastify';
import _ from 'lodash';

export default function useToastError(): (error: any, defaultMessage?: string) => void {
  // Capture the component context when the hook is used
  const initStack = new Error().stack;
  const caller = initStack?.split('\n')[2]?.trim();

  return (error: any, defaultMessage?: string) => {
    const isDev = import.meta.env.MODE === 'development';
    const toastOptions = {
      autoClose: isDev ? 5000 : 3000,
      closeButton: isDev,
      closeOnClick: isDev,
      pauseOnHover: isDev,
      draggable: false,
      progress: undefined,
    };

    let errorMessage = error.message;

    if (isDev) {
      console.log('[ToastError called from]:\n', caller, '\n', error);
      if (error.name === 'ApolloError') {
        if (!_.isEmpty(error.networkError)) {
          const { statusCode } = error.networkError;
          if (statusCode < 500) {
            const [message] = error.networkError?.result?.errors || [];
            const formatedError = (
              <div>
                {errorMessage} <br />
                {message.extensions.code} <br />
                {message.message} <br />
              </div>
            );

            errorMessage = formatedError;
          }
        }
      }

      toast.error(errorMessage, toastOptions);
    } else if (defaultMessage) {
      toast.error(defaultMessage, toastOptions);
    }
  };
}
